export const REPORT_BUGS_LINKS = [
  {
    key: 'report_bus',
    title: 'Reportar Bugs',
    externalUrl: 'https://forms.gle/gPv6Sn6d4SGPaUnb6',
  },
  {
    key: 'report_difficulties',
    title: 'Reportar Dificuldades ou reclamações',
    externalUrl: 'https://forms.gle/4RrWukJ3eaef4R3x6',
  },
]
